// import html2canvas from 'html2canvas'
/**
 * 渲染html
 * @param {*} editorExe 编辑器实例
 * @param {*} options 配置
 * @returns 渲染后的canvas
 */
export const getCanvasByDom = async (editorExe, options = {}) => {
  try {
    let editor = null

    // 如果直接提供了DOM元素，优先使用
    if (options.element) {
      editor = options.element
    } else {
      if (!editorExe) {
        throw new Error('编辑器实例为空')
      }

      if (options.querySelectorName) {
        // 如果提供了特定选择器，先尝试在编辑器文档中查找
        try {
          editor = editorExe.dom.doc.querySelector(options.querySelectorName)
        } catch (e) {
          console.warn('在编辑器文档中查找元素失败:', e)
        }
        // 如果在编辑器文档中找不到，尝试在主文档中查找
        if (!editor) {
          editor = document.querySelector(options.querySelectorName)
        }

        // 如果还是找不到，尝试在编辑器容器中查找
        if (!editor) {
          const container = editorExe.getContainer()
          if (container) {
            editor = container.querySelector(options.querySelectorName)
          }
        }

        // 如果没有找到特定元素，使用默认的编辑器body
        if (!editor) {
          editor = editorExe.getBody()
        }

        // 最后的兜底方案：使用编辑器容器
        if (!editor) {
          editor = editorExe.getContainer()
        }
      } else {
        // 如果没有提供特定选择器，使用默认的编辑器body
        editor = editorExe.getBody()

        // 兜底方案：使用编辑器容器
        if (!editor) {
          editor = editorExe.getContainer()
        }
      }
    }

    if (!editor) {
      throw new Error('无法找到有效的DOM元素进行渲染')
    }
    // 获取电脑分辨率避免图片模糊
    const scale = window.devicePixelRatio || 1

    const canvas = await html2canvas(editor, {
      useCORS: true,
      scale,
      allowTaint: true,
      ...options,
    })

    if (!canvas) {
      throw new Error('html2canvas 返回了空的 canvas')
    }
    return { canvas, devicePixelRatio: scale }
  } catch (error) {
    throw new Error(`渲染失败: ${error.message}`)
  }
}
